<template>
    <div
        class="body-2 cursor-pointer"
        @click="$emit('select')"
    >
        <div class="body-2">
            <template v-if="willEmailNotBeSent">
                <span v-html="isSendingText" /> <!-- INPUT FROM STATIC TRANSLATION -->
                <span class="n5--text subtitle-2 font-weight-bold"> “{{ emailAutomation.subject }}“</span>
                <span> {{ $t("automatically") }}</span>
            </template>
            <template v-else-if="TaskAutomationLogModule.isEmailAutomationToBeSentImmediately(emailAutomation)">
                <span v-html="isSendingText" /> <!-- INPUT FROM STATIC TRANSLATION -->
                <span class="n5--text subtitle-2 font-weight-bold"> “{{ emailAutomation.subject }}“</span>
                <span> {{ $t("in any minute") }}</span>
            </template>
            <template v-else>
                <span v-html="isSendingText" /> <!-- INPUT FROM STATIC TRANSLATION -->
                <span class="n5--text subtitle-2 font-weight-bold"> “{{ formattedSubject }}“ </span>
                <template v-if="TaskAutomationLogModule.getDateText(emailAutomation)">
                    {{ $t('on {0},').format(TaskAutomationLogModule.getDateText(emailAutomation)) }}
                </template>
                <span>{{ TaskAutomationLogModule.getDaysText(emailAutomation) }} </span>
                <span class="subtitle-2">{{ TaskAutomationLogModule.getTriggerText(emailAutomation) }} </span>
            </template>
            <template v-if="showTaskTitle && emailAutomation.task_id">
                (<span>{{ $t("Task") }} </span>
                <span class="n5--text subtitle-2 font-weight-bold">“{{ emailAutomation.task_title }}“</span>)
            </template>
            <div v-if="sendNowEnabled && (emailAutomation.trigger && emailAutomation.trigger !== '') && emailAutomation.id">
                <span>
                    <span>{{ $t("or") }} </span>
                    <span class="n3--text subtitle-2 text-decoration-underline cursor-pointer" @click.stop="$emit('send-now')">{{ $t("Send now") }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import TaskAutomationLogModule from "@/modules/emailing/taskAutomationLog"
import { computed } from "@vue/composition-api";
import EmailAutomationModule from "@/store/modules/email_automation";

export default {
    name: "PlannedEmailText",
    props: {
        emailAutomation: {
            type: Object,
            required: true
        },
        sendNowEnabled: {
            type: Boolean,
            default: false
        },
        showTaskTitle: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const { emailAutomationTemplates } = EmailAutomationModule()

        const willEmailNotBeSent = computed(() => props.emailAutomation.id && !props.emailAutomation.run_at && props.emailAutomation.trigger && props.emailAutomation.trigger !== 'finished' && props.sendNowEnabled)

        const isSendingText = computed(() => {
            if (willEmailNotBeSent.value) {
                return $t('Uku will no longer send email')
            }

            return $t("Uku <span class='subtitle-2'>is sending</span> email")
        })

        const getTemplateRow = () => {
            const template = emailAutomationTemplates.value.find(x => x.id === props.emailAutomation.content_template_id)
            if (!template) {
                return
            }

            return template.rows.find(x => x.locale_code === props.emailAutomation.locale_code)
        }

        const formattedSubject = computed(() => {
            let content = props.emailAutomation.subject

            if (props.emailAutomation.content_template_id) {
                const templateRow = getTemplateRow()
                if (templateRow) {
                    content = templateRow.subject
                }
            }

            if (!content) {
                return ""
            }

            return content
        })

        return {
            TaskAutomationLogModule,
            isSendingText,
            formattedSubject,
            willEmailNotBeSent
        };
    }
};
</script>

